<template>
  <v-container class="white-wrapper" fluid>
    <div class="d-flex flex-column align-center justify-center">
      <v-img class="mt-5" src="@/assets/img/event-img.png" />
      <div style="width: 100%" class="px-5">
        <v-btn
          class="font-weight-bold text-h5"
          style="color: #22224b"
          color="white"
          x-large
          block
          @click="confirmModal = true"
        >
          참여하기
        </v-btn>
      </div>
    </div>
    <v-dialog v-model="confirmModal" persistent max-width="30rem">
      <v-card>
        <v-card-title></v-card-title>
        <v-card-text
          style="
            min-height: 5rem;
            display: flex;
            align-items: center;
            justify-content: center;
          "
        >
          신청하시겠습니까?
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="pa-0">
          <v-btn
            color="#AFAFAF"
            width="50%"
            text
            x-large
            class="font-weight-bold"
            @click="confirmModal = false"
          >
            취소
          </v-btn>
          <v-divider vertical></v-divider>
          <v-btn
            color="primary"
            width="50%"
            text
            x-large
            class="font-weight-bold"
            @click="apiCall"
          >
            참여하기
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="successModal" max-width="30rem" persistent>
      <v-card>
        <v-card-title></v-card-title>
        <v-card-text
          style="
            min-height: 5rem;
            flex-direction: column;
            display: flex;
            align-items: center;
            justify-content: center;
          "
        >
          <div class="font-weight-bold text-subtitle-1">CCS 지급 완료</div>
          <div>Home에서 CCS를 확인하세요.</div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="pa-0">
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            width="100%"
            text
            x-large
            to="/home"
            class="font-weight-bold"
          >
            홈으로 이동
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="messageModal" max-width="30rem">
      <v-card>
        <v-card-title></v-card-title>
        <v-card-text
          v-html="message"
          style="
            min-height: 5rem;
            display: flex;
            align-items: center;
            justify-content: center;
          "
        >
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="pa-0">
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            width="100%"
            text
            x-large
            @click="messageModal = false"
            class="font-weight-bold"
          >
            {{ $t('close') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      confirmModal: false,
      successModal: false,
      messageModal: false,
      message: ''
    }
  },
  computed: {
    title() {
      const name = this.$route.name

      return name.charAt(0).toUpperCase() + name.slice(1)
    }
  },
  created() {
    this.$store.commit('loading', false)
  },
  methods: {
    apiCall() {
      this.$store.commit('loading', true)
      this.$store
        .dispatch('event_add')
        .then((res) => {
          this.$store.commit('loading', false)
          // console.log(res)
          if (res.data && res.data.result) {
            this.confirmModal = false
            this.successModal = true
          } else throw res.data
        })
        .catch((err) => {
          this.$store.commit('loading', false)
          console.log(err)
          this.confirmModal = false
          this.message = `신청에 실패하였습니다.<br/>다시 시도해주세요.`
          if (err.message) this.message = err.message
          this.messageModal = true
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.white-wrapper {
  background: #22224b;
  // background-image: url('~@/assets/img/event-bg.png');
  // background-size: cover;
  // background-position: 0 -50px;
}
</style>
